import { Dispatch, SetStateAction } from "react"
import styles from "./Uuid.module.css"

interface uuidProps {
    click: Dispatch<SetStateAction<boolean>>
}

export default function Uuid({click}: uuidProps) {
    return(
        <button onClick={e => {
            click(true)
        }} className={styles.mainB}>
            <img className={styles.idImage} src="/buttons/id.png" alt="uuid" />
        </button>
    )
}